import apiClient from './api-client';

export interface FXConversion {
  converted_amount: number;
  exchange_rate: number;
  from_currency: string;
  to_currency: string;
}

export interface FXRate {
  from_currency: string;
  to_currency: string;
  rate_date: string;
  exchange_rate: number;
}

export interface FXRateCreate {
  from_currency: string;
  to_currency: string;
  rate_date: string;
  exchange_rate: number;
}

export const fxRatesService = {
  /**
   * Convert amount from one currency to another
   */
  async convertCurrency(
    amount: number,
    fromCurrency: string,
    toCurrency: string
  ): Promise<FXConversion> {
    const response = await apiClient.get('/api/v1/fx-rates/convert', {
      params: {
        amount,
        from_currency: fromCurrency,
        to_currency: toCurrency,
      },
    });
    return response.data;
  },

  /**
   * Get all FX rates
   */
  async getFXRates(): Promise<FXRate[]> {
    const response = await apiClient.get('/api/v1/fx-rates/');
    return response.data;
  },

  /**
   * Create or update FX rates in bulk
   */
  async updateFXRates(rates: FXRateCreate[]): Promise<void> {
    await apiClient.post('/api/v1/fx-rates/bulk', rates);
  },

  /**
   * Get latest FX rates for a specific date
   */
  async getFXRatesForDate(date: string): Promise<FXRate[]> {
    const response = await apiClient.get('/api/v1/fx-rates/', {
      params: { rate_date: date },
    });
    return response.data;
  },

  /**
   * Get available currency pairs
   */
  async getCurrencyPairs(): Promise<string[]> {
    const response = await apiClient.get('/api/v1/fx-rates/pairs');
    return response.data;
  },
};
